import { SelectionCategories } from '@revelio/iso-utility';

import type { EntitySelections } from '../../report-builder.model';
import { isACompanySelectionList } from './report-entity-selections/report-entity-selections-legacy-modal-helpers';
import type { ReportSelectionCategories } from './utils';

export const adaptiveRicsFromReportSelections = (
  selections: EntitySelections | undefined
) => {
  const rics: {
    rics_k10: string[];
    rics_k50: string[];
    rics_k400: string[];
  } = {
    rics_k10: [],
    rics_k50: [],
    rics_k400: [],
  };

  Object.values(selections ?? {}).forEach((selGroup) => {
    Object.values(selGroup).forEach((item) => {
      if (!item.item) return;

      // build rics selections
      switch (
        isACompanySelectionList(
          item.selectionListId as ReportSelectionCategories
        )
          ? 'company'
          : item.selectionListId
      ) {
        case SelectionCategories.RICS_K10:
          rics.rics_k10.push(item.id);
          break;
        case SelectionCategories.RICS_K50:
          rics.rics_k50.push(item.id);
          break;
        case SelectionCategories.RICS_K400:
          rics.rics_k400.push(item.id);
          break;
        case 'company':
          if (item.item?.rics_k10) {
            rics.rics_k10.push(String(item.item.rics_k10));
          }
          if (item.item?.rics_k50) {
            rics.rics_k50.push(String(item.item.rics_k50));
          }
          if (item.item?.rics_k400) {
            rics.rics_k400.push(String(item.item.rics_k400));
          }
          break;
      }
    });
  });

  return rics;
};
